import type { UserGroupManagerOverviewApiData, UserGroupManagerOverviewApiResponses } from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

// The worker app's manager-mode customer screen: contacts, cars and upcoming bookings in one call.
export const managerOverviewUrls = {
  getUserGroupManagerOverview: dataEndpoint<UserGroupManagerOverviewApiData, UserGroupManagerOverviewApiResponses>({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/manager-overview/`)
  })
};
